/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReferralCreationEmailNotificationSummary } from './referral-creation-email-notification-summary';


export interface ReferralCreationEmailNotificationListResponse { 
    aggregateStatus?: ReferralCreationEmailNotificationListResponse.AggregateStatusEnum;
    notifications?: Array<ReferralCreationEmailNotificationSummary>;
    programReferralId?: string;
}
export namespace ReferralCreationEmailNotificationListResponse {
    export const AggregateStatusEnum = {
        NoMessages: 'NO_MESSAGES',
        Pending: 'PENDING',
        Processing: 'PROCESSING',
        Sent: 'SENT',
        PartiallySent: 'PARTIALLY_SENT',
        Failed: 'FAILED',
        Suppressed: 'SUPPRESSED'
    } as const;
    export type AggregateStatusEnum = typeof AggregateStatusEnum[keyof typeof AggregateStatusEnum];
}


